import { ReactIcon } from '@/components/react/ui/ReactIcon';
import { Dialog } from '@base-ui-components/react/dialog';

export const ModalCloseCta = ({ closeText }: { closeText: string }) => (
  <Dialog.Close className="text-blurb-text-link flex cursor-pointer flex-nowrap items-center gap-1 text-sm/relaxed">
    {closeText} <ReactIcon name="close" size="small" />
  </Dialog.Close>
);
